export const chatConfig = {
  maxCharacters: 64
};

export interface ChatSettings {
  length?: ResponseLength;
  narrationStyle?: NarrationStyle;
  pointOfView?: PointOfView;
  customInstructions?: string;
}

export type ResponseLength = "short" | "medium" | "long";
export type NarrationStyle = "roleplay" | "text";
export type PointOfView = "first" | "second" | "third";

export interface Chat {
  id: number;
  charIDs: number[];
  personaID: number;
  isStudio: boolean;
  memory?: string;
  settings: ChatSettings;
  createdAt: string;
  updatedAt?: string;
}

export interface ChatInsert {
  charIDs: number[];
  personaID: number;
  isStudio?: boolean;
  memory?: string;
  settings?: ChatSettings;
}

export interface ChatUpdate {
  id: number;
  charIDs?: number[];
  personaID?: number;
  memory?: string;
  settings?: ChatSettings;
}
